import ctrlCampos from '@/modules/workflow/forms/ctrl-campos/store';
import ctrlFormularioDinamico from '@/modules/workflow/forms/ctrl-formularios-dinamicos/store'
const store = {
  ctrlCampos,
  ctrlFormularioDinamico
}

export default store